import { Ship } from '@models/shipping';
import { Payment } from '@models/paiement';
import { Address, User } from '@models/user';

export class Discount{
	ident: string;
	name: string;
	codeNumber: string;
	amount: number=0;
	amountUsed: number;
	type: '%' | '€'='%';
	isReusable: boolean=false;
	state: string;
}

export class StateOrder{
	ident: string;
	name: string;
	mail: string;
	editable: boolean=true;
	state: 'actif' | 'supprimé'='actif';
}

export class Order{
	static readonly STATE_COMPLETE="state-complete"; 	//commande complétée
	static readonly STATE_PAYED="state-payed"; 		//commande payée
	static readonly STATE_SEND="state-send"; 			//commande envoyée
	static readonly STATE_PREPARED="state-prepared"; 	//commande préparée pour le click&collect
	static readonly STATE_PICKUP="state-pickup"; 		//commande récupérée pour le click&collect
	static readonly STATE_REMOVED="state-removed"; 	//commande supprimée

	ident?: string;
	dateCreate: string;
	customer: string;
	address: string | Address;
	addressInvoice?: string | Address;
	dCollect?: string;
	hCollect?: string=null;
	discount?: string;
	relayPoint?: string;
	shipper?: string;			//uniquement pour l'envoi au ws création commande
	amountHT: number;
	amountTTC: number;
	amountShipping: number;
	amountShippingHT: number;
	weight: number;
	publicComment: string;
	privateComment?: string;
	state: string;
	transactions: Transaction[]=[];
	notes: OrderNote[]=[];
  newPrivateNote?: string;
	ship?: string;
	shipObj?: Ship;
	payment?: string;
	paymentObj?: Payment;
	addressObj?: Address;
	addressInvoiceObj?: Address;
	customerObj?: User;
	refunds: Refund[]=[];
}

export class Transaction{
	ident?: string;
  product?: string;
	refund?: string;	//refund
	tRefund?: string;	//transaction refund
	price: string;
	qte: number;
	name?: string;
	ref?: string;
	tva?: number;
	amountHT?: number;
	amountTTC?: number;
	amountHTRemise?: number;
	amountTTCRemise?: number;
	amountTVA?: number;
  giftWrapping?: string;

	constructor(price?: string, qte?: number, giftWrapping?: string){
		this.price = price;
		this.qte = qte;
    this.giftWrapping = giftWrapping;
	}
}

export class OrderNote {
  id: number;
  orderIdent: string;
  utilIdent: string;
  userFirstName: string;
  dateCreate: string;
  type: 'public' | 'private';
  content: string;
  state: string;
}

export class OrderNoteRequest {
  note: number | null = null;
  content: string | null = null;
  type: 'public' | 'private';
}

export class Refund{
	ident: string;
	idOrder: string;
	dCreate: string;
	hCreate: string;
	payment: string;
	amountHT: number;
	amountTTC: number;
	weight: number;
}

export class RefundRequest{
	transactions: {transaction: string, qte: number}[];
	restock: boolean=true;
	paymentType: 'paypal-payment' | 'tpe-payment' | 'divers-payment'=null;
	refund: boolean=true;
}
